import { render, staticRenderFns } from "./status-indicator.html?vue&type=template&id=1bd2a408&scoped=true&"
import script from "./status-indicator.ts?vue&type=script&lang=js&"
export * from "./status-indicator.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2a408",
  null
  
)

export default component.exports